import { CarouselKey, CarouselProps } from 'components/Phantom/_shop/Carousel/types'
import { CarouselDefaults } from 'components/Phantom/_shop/defaults'

// TODO this can live anywhere. It's just a mapping of keys to props.
//  It could also be changed into a function if we wanted to add more lookup arguments, such as the current selection or something.
export const CarouselMapping: Record<CarouselKey, CarouselProps> = {
	example: CarouselDefaults,
}
